import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

// const DOC_PATH = '../../../../../assets/docs'

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggleOpen, toggleClose,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggleOpen(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggleClose()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = async (idgestion) => {
        navigate(`/cajas/gestiones/formulario`)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllManagements = async () => {

        const { fetchManagements } = FetchData
        const { executeFetch } = fetchManagements

        executeFetch()

    }

    const handleClickFetchSpecificManagement = async (idgestion) => {
        
        navigate(`/cajas/gestiones/formulario/${idgestion}`)

    }

    const handleClickDeleteManagement = async (idgestion) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/cashier-managements/delete-management/${idgestion}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllManagements()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickDownloadDoc = (documentName) => {
        const enlaceTemporal = document.createElement('a');
        enlaceTemporal.href = require(`../../../../../assets/docs/${documentName}`);
        enlaceTemporal.download = documentName;
        document.body.appendChild(enlaceTemporal);
        enlaceTemporal.click();
        document.body.removeChild(enlaceTemporal);
    }

    const handleClickShowPdfAdminToCentral = async (idgestion) => {

        const { fetchPdfAdminToCentral } = FetchData

        fetchPdfAdminToCentral.setParamsToSearch({
            idgestion: idgestion
        })
        fetchPdfAdminToCentral.executeFetch()

        abrirModal(
            '',
            'VISOR DE DOCUMENTO',
            'ReportViewer',
            { }
        )

    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllManagements,
        handleClickFetchSpecificManagement,
        handleClickDeleteManagement,
        handleClickDownloadDoc,
        handleClickShowPdfAdminToCentral
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}